// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"Avatar_root__NqYTW","img":"Avatar_img__K6krr"};